import { render, staticRenderFns } from "./caseModelA.vue?vue&type=template&id=2df576d8&scoped=true"
import script from "./caseModelA.vue?vue&type=script&lang=js"
export * from "./caseModelA.vue?vue&type=script&lang=js"
import style0 from "./caseModelA.vue?vue&type=style&index=0&id=2df576d8&prod&lang=scss&scoped=true"
import style1 from "./caseModelA.vue?vue&type=style&index=1&id=2df576d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df576d8",
  null
  
)

export default component.exports